import { safeGet } from '../../../utils/safeGet'
import { hasExportPermission } from '../../../utils/exportPermission'
import { get as _get, post as _post } from '../../../utils/fetcher'
import { mapDataForFairmatProductScore } from '../../../utils/drivers'
import {
  filterByWord,
  filterByIssuerCode,
  filterByCompatibility,
  filterByScoreValue,
  getIssuersList,
} from '../../../utils/filters'

export default {
  namespaced: true,

  state: {
    insight: null,
    filteredProducts: [],
  },

  mutations: {
    setInsight(state, data) {
      state.insight = data
    },
    setFilteredProducts(state, payload) {
      state.filteredProducts = payload
    },
  },

  actions: {
    resetState({ state }) {
      state.insight = null
      state.filteredProducts = []
    },
    loadInsight({ commit, getters, dispatch }, scoringProfileId) {
      // Always goes through the catalog compatibility engine.
      dispatch('scoringProfilesCommon/setLoading', true, { root: true })
      return new Promise((resolve, reject) => {
        _get(`/api/insights/details/${scoringProfileId}`)
          .then((data) => {
            commit('setInsight', data)
            dispatch('initFilteredProducts', data.productsDetail)
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            dispatch('scoringProfilesCommon/setLoading', false, { root: true })
          })
      })
    },
    initFilteredProducts({ commit }, array) {
      const mapData = array.map((el, i) => {
        return {
          ...el,
          index: i,
          name: el.productName,
          productScore: mapDataForFairmatProductScore(el.productScore),
          score: safeGet(() => el.productScore.scoreResults.filter((x) => x.show4Product)[0].totalScore, null),
          scoringProfile: safeGet(() => el.scoringProfile.name, null),
          compatibilityType: safeGet(() => el.scoringProfile.compatibilityType, null),
          isAssociated: safeGet(() => el.scoringProfile.isAssociated, false),
        }
      })
      commit('setFilteredProducts', mapData)
    },
    filteredProducts({ getters, commit }, filters) {
      let list = getters.getInsightMapped

      if (filters.queryString !== '') {
        list = filterByWord(list, filters.queryString)
      }

      if (filters.issuers.length > 0) {
        list = filterByIssuerCode(list, filters.issuers)
      }

      if (filters.compatibility.length > 0) {
        list = filterByCompatibility(list, filters.compatibility)
      }

      if (filters.scoreF !== null && filters.scoreT !== null) {
        list = filterByScoreValue(list, filters.scoreF, filters.scoreT)
      }

      commit('setFilteredProducts', list)
    },
  },

  getters: {
    getInsight: (state) => {
      return safeGet(() => state.insight, null)
    },
    getFilteredProducts: (state) => {
      return safeGet(() => state.filteredProducts, [])
    },
    getInsightMapped: (state) => {
      if (!state.insight) return []
      const mapData = state.insight.productsDetail.map((el, i) => {
        return {
          ...el,
          index: i,
          name: el.productName,
          productScore: mapDataForFairmatProductScore(el.productScore),
          score: safeGet(() => el.productScore.scoreResults.filter((x) => x.show4Product)[0].totalScore, null),
          scoringProfile: safeGet(() => el.scoringProfile.name, null),
          compatibilityType: safeGet(() => el.scoringProfile.compatibilityType, null),
          isAssociated: safeGet(() => el.scoringProfile.isAssociated, false),
        }
      })
      return mapData
    },
    getInsightProducts: (state, getters) => {
      const mapData = getters.getInsightMapped

      const objData = {
        productsMarketSegment: mapData.filter((el) => el.isMarketSegment),
        productsUnderDistribution: mapData.filter((el) => el.isUnderDistribution),
        productsUnderTesting: mapData.filter((el) => el.isUnderTesting),
      }
      return objData
    },
    getExportPermission(state, getters, rootState, rootGetters) {
      return hasExportPermission(rootGetters.getPermissions)
    },
    getCoverageIssuersList(state) {
      return getIssuersList(state.insight.productsDetail)
    },
  },
}
